<template>
    <div>
      <div v-if="readabilityLevel">
        {{ readabilityLevelOptions.filter(option => option.value === readabilityLevel)?.[0].text }}
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not selected
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewReadabilityLevel',
    props: [
        'readabilityLevelOptions',
        'readabilityLevel',
    ],
}
</script>

<style lang="scss" scoped>

</style>